import mitt from 'mitt';
export function bootstrapEvents() {
    window.M.theme_soon = window.M.theme_soon || {};
    window.M.theme_soon.events = mitt();
    window.M.theme_soon.events.on('*', (message) => {
        console.debug('EVENT', message);
    });
}
